module.exports = __webpack_public_path__ + "static/media/cover.53b91393.jpg";